<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap');

.container {
  max-width: 1170px !important;

}

.form-retailers {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  align-content: start;
  position: relative;
  top: 100px;
  margin-top: 200px;
  padding-bottom: 100px;
}

.form-retailers .top-title {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.form-retailers .top-title h1 {
  font-size: 64px;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.02em;
  font-family: "Montserrat";
  color: #3D4053;
}

.form-retailers .top-title h2 {
  font-size: 64px;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.02em;
  font-family: "Montserrat";
  color: #3D4053;
}

.form-retailers .form-step1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 100px;
  /* margin-bottom: 50px; */
  width: 100%;
}

.form-retailers .form-step1 .form-input {
  flex-direction: column;
  align-items: flex-start;
  width: 80%;
  text-align: center;
  display: flex;
  justify-content: start;
  margin-top: 15px;
  margin-bottom: 15px;
}

.form-retailers .form-step1 .form-input input {
  width: 98%;
  height: 56px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 15.72px;
  font-size: 18px;
  align-items: center;
  padding: 17px;
}

.form-retailers .form-step1 .form-input label {
  font-family: 'Montserrat';
  font-size: 24px;
  font-weight: 600;
}

::placeholder {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.3);
}

.form-retailers .form-step1 .form-input input:focus {
  outline: none;
}

.form-error {
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  width: 100%;
  margin-bottom: 50px;
}

.form-submit {
  display: flex;
  justify-content: start;
  align-items: center;
  align-content: center;
  width: 100%;
}

.form-submit .submit-btn {
  color: #fff;
  background: linear-gradient(267.53deg, #FF3CA5 0%, #CA74FF 100%);
  height: 64px;
  border: none;
  border-radius: 17px;
  width: 286px;
  font-size: 20px;
  font-weight: 700;
  font-family: 'Montserrat';
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.0196802), 
  0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0282725), 
  0px 22.3363px 17.869px rgba(0, 0, 0, 0.035), 
  0px 12.5216px 10.0172px rgba(0, 0, 0, 0.0417275), 
  0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0503198), 
  0px 2.76726px 2.21381px rgba(0, 0, 0, 0.07);
}

@media only screen and (max-width: 768px) {
  .form-retailers .top-title h1 {
    font-size: 36px;
  }

  .form-retailers .top-title h2 {
    font-size: 36px;
  }
  .form-retailers .form-step1 {
    width: 100%;
    flex-direction: column;
    margin-bottom: 50px;
    margin-top: 50px;
  }

  .form-retailers .form-step1 .form-input {
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .form-retailers .form-step1 .form-input input {
    width: 100%;
    font-size: 18px;
  }

  .form-submit {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: 100%;
  }

  .form-retailers .top-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
  }
}
</style>

<template>
  <div>
    <MainMenu />
    <div class="container">
      <div class="form-retailers">
        <div class="top-title">
          <h1>Let's Start</h1>
          <h2>Finding Influencers</h2>
        </div>
        <div class="form-step1" id="hubspotForm"></div>
      </div>
    </div>
  </div>
</template>


<script>

import router from "../router.js";
import { mapState, mapActions } from "vuex";

import MainMenu from "../components/MainMenu";

hbspt.forms.create({
  region: "na1",
  portalId: "21143660",
  formId: "949221fb-1370-4293-8952-d9f8d5c37b7b",
  target: "#hubspotForm",
  onFormSubmit: function () {
    var gtag_report_conversion = function(url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
          'send_to': 'AW-10944536239/sMNvCP2Ky4sYEK-94eIo',
          'event_callback': callback
      });
      return false;
    }
    gtag_report_conversion();
  },
});
export default {
  name: "RetailersForm",
  components: {
    MainMenu,
  },
};
</script>
